import APIHelper from 'helpers/APIHelper';
import { AuthorizationTypeEnum } from 'helpers/enums';
import { IBearerToken, IHeader } from 'helpers/interfaces';
import WebResponse from 'helpers/WebResponse';

export default class API {

    /* FUTURE: SSO
        public static async SSOTokenAsync(): Promise<IBearerToken> {
    
            //At this point, the serven has already authenticated and created a session cookie. 
            // We will hit this special token endpoint that requires 
            const baseurl = APIHelper.GetBaseURL();
            const query: string = `${baseurl}/SSOToken`;
    
            // const wr = APIHelper.GetAsyncWithoutToken<IBearerToken>(query);
            let details = {
                grant_type: "sso"
            }
    
            const wr = await APIHelper.GetUrlEncodedAsync<IBearerToken>(query, details, false);
    
    
            return wr.Result;
    
        }
    */

    /**
     * Sign in using the secure POST endpoint.
     * Credentials are sent in the request body instead of URL parameters.
     */
    public static async SignInAsync(username: string, password: string, authType: AuthorizationTypeEnum, configuratorKey?: string): Promise<WebResponse<any>> {

        const query: string = `api/auth/SignIn`;

        const body = {
            userName: username,
            password: password,
            authType: (authType === AuthorizationTypeEnum.CSR ? "csr" : "standard"),
        };

        let headerArray: IHeader[] = [];
        if (configuratorKey) {
            headerArray = [
                {
                    name: "X-Integration-Key",
                    value: configuratorKey
                }
            ];
        }

        // Using POST instead of GET to keep credentials secure
        const response = await APIHelper.PostAsync(query, undefined, body, false, headerArray);

        return response;
    }

    public static async SignInWithRemoteIDAsync(userName: string, remoteID: string): Promise<WebResponse<any>> {

        const query: string = `api/auth/SignInWithRemoteID`;

        const details = {
            userName: userName,
            remoteID: remoteID,
        };

        const response = await APIHelper.GetAsync(query, details, undefined, false);

        return response;
    }

    public static async SignInWithOnlineAckTokenAsync(token: string): Promise<WebResponse<any>> {
        const query = `api/auth/SignInWithOnlineAckToken`;

        const details = {
            token: token,
        }

        const response = await APIHelper.GetAsync(query, details, undefined, false);

        return response;
    }
    
    /**
     * Acquire a JWT token using the secure POST endpoint.
     * Credentials are sent in the request body instead of URL parameters.
     */
    public static async TokenAsync(username: string, password: string, authType: AuthorizationTypeEnum, configuratorKey?: string): Promise<WebResponse<IBearerToken>> {

        let query: string = `api/auth/Token`;

        /*if (authType === AuthorizationTypeEnum.CSR) {
            query = `api/auth/CSRToken`;
        }*/

        let body = {
            userName: username,
            password: password,
        }

        let headerArray: IHeader[] = [];
        if (configuratorKey) {
            headerArray = [
                {
                    name: "X-Integration-Key",
                    value: configuratorKey
                }
            ];
        }

        // Using POST instead of GET to keep credentials secure
        const response = await APIHelper.PostAsync<IBearerToken>(query, undefined, body, false, headerArray);

        return response;

    }
    
    public static async GetRefreshTokenAsync(): Promise<WebResponse<string>> {

        let query: string = `api/auth/refreshtoken`;

        const response = await APIHelper.GetAsync<string>(query, undefined, undefined, false);

        return response;

    }

}